import { Injectable } from '@angular/core';
import { ResourceBaseUrlBuilder } from '@core/api/resource-base-url-builder';
import { standardizeUrl } from '@core/utils';

@Injectable({ providedIn: 'root' })
export class AccountsResourceBaseUrlBuilder implements ResourceBaseUrlBuilder {
  public buildBaseUrl(): string {
    return standardizeUrl(`accounts`);
  }
}
